<template>
  <f7-page id="register-myinfo-verify-page" name="register-myinfo-verify-page" @page:beforein="init()" @page:afterin="afterin">
    <f7-navbar class="view-mobile no-border">
        <f7-nav-left class="back-button">
            <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
    </f7-navbar>

    <f7-block>
      <div class="mb-md text-align-left fs-24 fw-bold"> {{$t('ua-personal-detail-title')}}</div>
      <div class="mb-xxl text-color-gray fs-14 fw-medium">{{$t('ua-personal-detail-desc')}}</div>

      <transition name="fade">
        <f7-card
            class   ="alert alert-danger mb-md w-100"
            v-show  ="alertCard.show"
        >
          <f7-card-header>
            <span v-html="alertCard.title"></span>
          </f7-card-header>
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
        </f7-card>
      </transition>


      <div class="mb-xxl">
        <MyInfoIdNo
          :key="key.identificationNo"
          :isShow=showHideInput.identificationNo
          :isDisabled=isFieldDisabled.identificationNo
          @validateNextButton="validateNextButton"
          @setInputValue="setInputValue"
        />

        <MyInfoFullname
          :key="key.fullName"
          :isShow=showHideInput.fullName
          :isDisabled=isFieldDisabled.fullName
          @validateNextButton="validateNextButton"
          @setInputValue="setInputValue"
        />

        <MyInfoGender
          :key="key.gender"
          :isShow=showHideInput.gender
          :isDisabled=isFieldDisabled.gender
          @validateNextButton="validateNextButton"
        />

        <MyInfoDob
          :key="key.dob"
          :isShow=showHideInput.dob
          :isDisabled=isFieldDisabled.dob
          @validateNextButton="validateNextButton"
        />

        <MyInfoNationality
          :key="key.nationality"
          :isShow=showHideInput.nationality
          :isDisabled=isFieldDisabled.nationality
          :nationalityList="nationalityList"
          @validateNextButton="validateNextButton"
        />

        <f7-list id="" class="form-group" style="">
          <f7-list-input
            input-id     ="residentialStatus"
            name         ="residentialStatus"
            type         ="text"
            class        ="clickable-row use-chevron"
            :label       ="$t('regis-residential-status')"
            placeholder  =""
            :value       ="residentialStatus"
            autocomplete  ="off"
            v-show        ="showHideInput.residentialStatus"
            outline
            floating-label
            disabled
        ></f7-list-input>

        <f7-list-input
            input-id     ="passType"
            name         ="passType"
            type         ="text"
            class        ="clickable-row use-chevron"
            :label       ="$t('regis-pass-type')"
            placeholder  =""
            :value       ="passType"
            autocomplete  ="off"
            v-show        ="showHideInput.passType"
            outline
            floating-label
            disabled
        ></f7-list-input>

        <f7-list-input
            input-id     ="passStatus"
            name         ="passStatus"
            type         ="text"
            class        ="clickable-row use-chevron"
            :label       ="$t('regis-pass-status')"
            placeholder  =""
            :value       ="passStatus"
            autocomplete  ="off"
            v-show        ="showHideInput.passStatus"
            outline
            floating-label
            disabled
        ></f7-list-input>

        <f7-list-input
            input-id     ="passExpiryDate"
            name         ="passExpiryDate"
            type         ="text"
            class        ="clickable-row use-chevron"
            :label       ="$t('regis-pass-expiry-date')"
            placeholder  =""
            :value       ="passExpiryDate"
            autocomplete  ="off"
            v-show        ="showHideInput.passExpiryDate"
            outline
            floating-label
            disabled
        ></f7-list-input>
        </f7-list>

        <f7-list class="form-group">
          <f7-list-input
            input-id      ="employmentSector"
            id            ="industry-list"
            name          ="employmentSector"
            type          ="text"
            class         =""
            placeholder   =""
            :value        ="employmentSector"
            :label        ="$t('ua-employment-sector')"
            autocomplete  ="off"
            v-show        ="showHideInput.employmentSector"
            outline
            floating-label
            required
            :disabled    = "isFieldDisabled.employmentSector"
            :clear-button= "!isFieldDisabled.employmentSector"
          ></f7-list-input>
        </f7-list>

        <MyInfoEmail
          :key="key.email"
          :isShow=showHideInput.email
          :isDisabled=isFieldDisabled.email
          @validateNextButton="validateNextButton"
          @setInputValue="setInputValue"
        />

        <MyInfoAddress
          :key="key.address"
          :isShow=showHideInput.address
          :isDisabled=isFieldDisabled.address
          @validateNextButton="validateNextButton"
          @setInputValue="setInputValue"
        />

        <MyInfoEmployer
          :key="key.employerName"
          :isShow=showHideInput.employerName
          :isDisabled=isFieldDisabled.employerName
          @validateNextButton="validateNextButton"
          @setInputValue="setInputValue"
        />

        <div id="reg-myinfo-occupation">
          <f7-list class="form-group">
            <f7-list-input
              input-id      ="occupation"
              id            ="occupation-list"
              name          ="occupation"
              type          ="textarea"
              resizable
              class         =""
              placeholder   =""
              :value        ="occupation"
              :label        ="$t('regis-occupation')"
              autocomplete  ="off"
              v-show        ="showHideInput.occupation"
              outline
              floating-label
              required
              :disabled    = "isFieldDisabled.occupation"
              :clear-button= "!isFieldDisabled.occupation"
            ></f7-list-input>
          </f7-list>
          <div class="view-mobile" style="color: transparent">-</div>
        </div>

      </div>

      <f7-button large fill @click="submitForm" class="mt-5 view-desktop" :disabled="false">
          {{$t('general-btn-submit')}}
      </f7-button>
    </f7-block>

    <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
      <f7-button large fill @click="submitForm" :disabled="false">
          {{$t('general-btn-submit')}}
      </f7-button>
    </f7-toolbar>

    <f7-sheet class="wandr-sheet-modal" :opened="myInfoValidation.showSheet" @sheet:closed="myInfoValidation.showSheet = false" :close-by-backdrop-click="false">
        <f7-block>
            <div class="text-align-center mb-20">
              <i class="f7-icons icon-sheet-modal">checkmark_alt_circle_fill</i>
            </div>

            <div class="text-align-center mb-20 fw-bold fs-18 text-color-black" v-html="$t('regis-account-created')"></div>
            <div class="text-align-center mb-xxl fw-semibold fs-16">
              <!-- {{$t('regis-welcome', {name:fullName})}} -->
            </div>

            <f7-row class="mb-xl">
              <f7-button large fill @click="handleSheetButton" :disabled="false" class="w-100">
                  {{$t('label-common-close')}}
              </f7-button>
            </f7-row>
        </f7-block>
    </f7-sheet>

    <f7-sheet class="wandr-sheet-modal" :opened="isNeedToUploadPOA" @sheet:closed="isNeedToUploadPOA = false" :close-by-backdrop-click="false">
        <f7-block class="text-align-center">
            <img :src="require('@/assets/img/ekyc/ic_upload_poa.svg')" width="48" />

            <div class="text-align-center mb-20 fw-bold fs-18 text-color-black" v-html="$t('ua-confirm-upload-poa')"></div>
            <f7-block class="mb-xl">
              <f7-button large fill @click="confirmToUploadPOA(true)" :disabled="false" class="w-100">
                  {{$t('general-btn-upload-now')}}
              </f7-button>
              <f7-button large fill @click="confirmToUploadPOA(false)" :disabled="false" class="w-100 mt-sm">
                  {{$t('general-btn-upload-later')}}
              </f7-button>
            </f7-block>
        </f7-block>
    </f7-sheet>
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  //import { check } from '@/plugins/helper';

  import MyInfoIdNo from '../../components/myinfo-id-no.vue';
  import MyInfoFullname from '../../components/myinfo-fullname.vue';
  import MyInfoGender from '../../components/myinfo-gender.vue';
  import MyInfoDob from '../../components/myinfo-dob.vue';
  import MyInfoNationality from '../../components/myinfo-nationality.vue';
  //import MyInfoEmploymentSector from '../../components/myinfo-employment-sector.vue';
  import MyInfoEmail from '../../components/myinfo-email.vue';
  import MyInfoAddress from '../../components/myinfo-address.vue';
  import MyInfoEmployer from '../../components/myinfo-employer.vue';
  //import MyInfoOccupation from '../../components/register-myinfo-occupation.vue';


  import store from '../../store';
  import TokenService from '../../services/token-service';

  import { debounce } from 'lodash'; 

  export default {
    props: {
      isUpdateAccount: {
        type: Boolean,
        default: false
      }
    },
    mounted (){      
      /*
        1 = name
        2 = identification no
        3 = gender
        4 = nationality
        5 = dob
        6 = email
        7 = occupation
        8 = employment sector
        9 = address
        10 = employer
      */

      //this.setEnabledField("1,2,3,4,5,6,7,8,9,10"); // FOR TESTING : ENABLE ALL INPUT FIELDS

      this.setIsModifyAlias(false)
    },
    data() {
      return {
        isEmailValid        : false,
        isOccupationValid   : false,
        isNextButtonValid   : false,
        isFieldDisabled     : {
                identificationNo  : true,
                fullName          : true,
                gender            : true,
                dob               : true,
                nationality       : true,
                email             : true,
                occupation        : true,
                employmentSector  : true,
                address           : true,
                employerName      : true,
        },
        myInfoValidation    : {
                showSheet     : false,
                skipValidation: false,
                message       : "",
        },
        isUpdateMyInfoSuccess     : false,
        isNeedToUploadPOA         : false,
        selectedOccupation        : "",
        selectedIndustry          : "",
        occupationListState       : [],
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        componentOccupationKey    : 0,
        dobKey                    : 0,
        key:  {
            identificationNo      : 0,
            fullName              : 1000,
            gender                : 2000,
            dob                   : 3000,
            nationality           : 4000,
            passType              : 5000,
            passStatus            : 6000,
            employmentSector      : 7000,
            email                 : 8000,
            address               : 9000,
            employer              : 10000,
            occupation            : 11000
        }
      };
    },
    methods: {
      ...mapActions('myinfo', [
        'setAddress',
        'setDob',
        'setEmail',
        'setEmployerName',
        'setEmploymentSector',
        'setFullname',
        'setGender',
        'setIdentificationNo',
        'setNationality',
        'setOccupation',
        'setPassExpiryDate',
        'setPassStatus',
        'setPassType',
        'setResidentialStatus',
        'setEnabledField',
        'setIndustryList',
        'setOccupationList',
        'setNationalityList',
        'setIsOccupationValid',
        'validateInput',
        'validateOccupation',
        'showHideInputForm'
      ]),
      ...mapActions('registration', ['registerMyInfoUpdate','setIsAxsRegisterIdExist']),
      ...mapActions('customer', [
        'setIsModifyAlias',
      ]),
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      changeDob(dobVal){
        if(dobVal.trim() == ""){
          this.setDob(this.dob)
        }else{
          this.setDob(dobVal)
        }
      },

      async init(){
        const self = this;
        self.showPreloader();
        self.setDob(self.dob)

        console.log("OCCUPATION: "+this.occupation.trim())
        if(this.occupation.trim() != ""){
          this.isOccupationValid = true;
          await this.setIsOccupationValid(true)
        }


        //await this.renderCalendar();
        await this.getOccupationList();
        await this.renderGender();


        await this.renderAutoComplete("industry");

        // GET NATIONALITY LIST THEN RE-RENDER
        await this.getNationalityList();
        this.key.nationality += 1

        await this.showHideInputForm();
        await this.setInputDisabled();
        //await this.finalValidationBeforeSubmit();
        await this.validateNextButton();


        // AUTOCOMPLETE CLEAR BUTTON LISTENER
        self.Dom7("#occupation").on('input:clear', function (e) {
          //console.log("occupation cleared")
          e.preventDefault();
          e.stopImmediatePropagation();
          self.Dom7("#occupation").val('').trigger('input change')
          
          const app = self.$f7
          app.autocomplete.close("#occupation")
        })

        self.Dom7("#employmentSector").on('input:clear', function (e) {
          //console.log("employmentSector cleared")
          e.preventDefault();
          e.stopImmediatePropagation();
          self.Dom7("#employmentSector").val('').trigger('input change')
          
          const app = self.$f7
          app.autocomplete.close("#employmentSector")
        })

        self.hidePreloader();
      },

      async getNationalityList(){
        const self = this;
        const nationalityListPromise = await self.$api.staticData.getCountryList();
        self.setNationalityList(nationalityListPromise);

        this.renderNationality();
      },

      renderNationality(){
        const self = this;

        // NATIONALITY
        self.Dom7('.myinfo.popover-dropdown-nationality').on('popover:open', function () {
            self.$$(".myinfo.popover-dropdown-nationality").css({
                'visibility' : 'hidden',
            });
        });

        self.Dom7('.myinfo.popover-dropdown-nationality').on('popover:opened', function () {
            var thepopover = self.Dom7('.myinfo.popover-dropdown-nationality');
            const classes = thepopover[0].firstChild.classList;
            const popoverDirection = classes[1];

            const parentPosBottom = document.getElementById('nationality').getBoundingClientRect().bottom;
            const parentPosLeft = document.getElementById('nationality').getBoundingClientRect().left;
            const parentWidth = document.getElementById('nationality').getBoundingClientRect().width;
            console.log("NATIONALITY popoverDirection: "+popoverDirection);

            self.$$("#nationalityInput").removeClass("dropdown-list").addClass("dropdown-list");

            if(popoverDirection == "on-top" || popoverDirection == "on-left" || popoverDirection == "on-right"){
              self.$$(".myinfo.popover-dropdown-nationality").css({
                  'visibility' : 'visible',
                  'top' : (parentPosBottom) + 'px',
                  'width' : parentWidth + 'px',
                  'margin-left' : (parentPosLeft) + 'px',
              });
            } else if(popoverDirection == "on-bottom"){
              self.$$(".myinfo.popover-dropdown-nationality").css({
                  'visibility' : 'visible',
                  'margin-top' : (8) + 'px',
                  'width' : parentWidth + 'px',
                  'margin-left' : (parentPosLeft) + 'px'
              });
            }

        });

        self.Dom7('.myinfo.popover-dropdown-nationality').on('popover:closed', function () {
            self.$$("#nationalityInput").removeClass("dropdown-list");
        });
      },

      renderGender(){
        const self = this;
        self.Dom7('.myinfo.popover-dropdown-gender').on('popover:open', function () {
            self.$$(".myinfo.popover-dropdown-gender").css({
                'visibility' : 'hidden',
            });
        });

        self.Dom7('.myinfo.popover-dropdown-gender').on('popover:opened', function () {
            var thepopover = self.Dom7('.popover-dropdown-gender');
            const classes = thepopover[0].firstChild.classList;
            const popoverDirection = classes[1];
            console.log("GENDER popoverDirection: "+popoverDirection);

            const parentPosBottom = document.getElementById('gender').getBoundingClientRect().bottom;
            const parentPosLeft = document.getElementById('gender').getBoundingClientRect().left;
            const parentWidth = document.getElementById('gender').getBoundingClientRect().width;

            self.$$("#genderInput").removeClass("dropdown-list").addClass("dropdown-list");

            self.$$(".myinfo.popover-dropdown-gender").css({
                'visibility' : 'visible',
                'top' : (parentPosBottom) + 'px',
                'width' : parentWidth + 'px',
                'margin-left' : (parentPosLeft) + 'px'
            });
        });

        self.Dom7('.myinfo.popover-dropdown-gender').on('popover:closed', function () {
            self.$$("#genderInput").removeClass("dropdown-list");
        });
      },

      renderCalendar(){
        const self = this
        self.$f7.calendar.create({
          inputEl: '#dobold',
          openIn: 'popup',
          dateFormat: "dd-mm-yyyy",
          closeOnSelect: true,
        })
      },

      renderAutoComplete(el){
        const self = this;
        const app          = self.$f7;
        const $$            = self.Dom7;

        if(el == "occupation"){
          const occList = self.occupationList;
          self.selectedOccupation = self.occupation;
          self.autocompleteOccupation = app.autocomplete.create({
              inputEl: '#occupation',
              openIn: 'dropdown',
              class  : '',
              closeOnSelect: true,
              source: async function (query, render) {
                  await self.setOccupation(query);
                  //await self.validateInput({id: "occupation", value: query})
                  await self.validateNextButton()

                  let results = [];
                  if(query.length <= 2) { // need to enter min 3 chars since the occupation list > 3000
                      app.autocomplete.close("#occupation")
                      return;
                  }
                  if(query.length === 0) {
                      render(results);
                      return;
                  }
                  // Find Matched Items
                  Object.keys(occList).forEach(key => {
                      if(occList[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                          results.push(occList[key]);
                      }
                  })

                  // Render Items By Passing Array With Result Items
                  render(results.sort());
                  $$("#reg-myinfo-occupation").removeClass("pb-200").addClass("pb-200")
                  app.autocomplete.open("#occupation")
              },
              on: {
                change: async function (e) {
                  await self.setOccupation(e[0])
                  await self.validateInput({id: "occupation", value: e[0]})
                  await self.validateNextButton()

                  self.Dom7("#occupation").val(e[0]).trigger('input blur')
                },
                closed: function(){
                  console.log("autocomplete dropdown closed")
                  $$("#reg-myinfo-occupation").removeClass("pb-200")
                },
                opened(e){
                  //console.log(e)
                  if(e.items){
                    //console.log("items : "+e.items.length)
                    $$("#reg-myinfo-occupation").removeClass("pb-200").addClass("pb-200")
                  }else{
                    //console.log("no items")
                    $$("#reg-myinfo-occupation").removeClass("pb-200")
                  }
                }
              }
          });
        }else if(el == "industry"){
          self.Dom7("#employmentSector").on("focus", async function() {
              // GET INDUSTRY LIST BY OCCUPATION
              const industryListPromise = await self.$api.staticData.getIndustryList("myinfo");

              if(industryListPromise.status == "0429"){
                await self.setIndustryList(industryListPromise.result);
              }

              if(self.industryList.key){
                await self.setEmploymentSector(self.industryList.value)
                //await self.validateInput({id: "employmentSector", value: self.industryList.value})
                await self.validateNextButton()
              }
          });


          self.autocompleteIndustry = app.autocomplete.create({
              inputEl: '#employmentSector',
              openIn: 'dropdown',
              class  : '',
              closeOnSelect: true,
              source: async function (query, render) {
                  await self.setEmploymentSector(query);
                  //await self.validateInput({id: "employmentSector", value: query})
                  await self.validateNextButton()

                  const employmentSectorList = self.industryList;
                  // self.selectedIndustry = self.employmentSector;

                  let results = [];
                  if(query.length === 0) {
                      render(results);
                      return;
                  }

                  // Find Matched Items
                  await Object.keys(employmentSectorList).forEach(key => {
                      if(employmentSectorList[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                          results.push(employmentSectorList[key]);
                      }
                  })

                  // Render Items By Passing Array With Result Items
                  render(results.sort());
                  app.autocomplete.open("#employmentSector")
              },
              on: {
                change: async function (e) {
                  await self.setEmploymentSector(e[0])
                  await self.validateInput({id: "employmentSector", value: e[0]})
                  await self.validateNextButton()

                  self.Dom7("#employmentSector").val(e[0]).trigger('input blur')
                },
                closed: function(){
                  console.log("employmentSector autocomplete dropdown closed")
                },
                opened(e){
                  //console.log(e)
                  if(e.items){
                    console.log("total employment sector list : "+e.items.length)
                  }else{
                    console.log("employmentSector : no items")
                  }
                }
              }
          });

        }
      },

      setInputDisabled(){
        const enabledField      = this.enabledField;
        const arrEnabledField   = enabledField.split(',');

        /*
          1 = name
          2 = identification no
          3 = gender
          4 = nationality
          5 = dob
          6 = email
          7 = occupation
          8 = employment sector
          9 = address
          10 = employer
        */

        if(arrEnabledField.includes("1")){
          this.isFieldDisabled.fullName = false;
        }

        if(arrEnabledField.includes("2")){
          this.isFieldDisabled.identificationNo = false;
        }

        if(arrEnabledField.includes("3")){
          this.isFieldDisabled.gender = false;
        }

        if(arrEnabledField.includes("4")){
          this.isFieldDisabled.nationality = false;
        }

        if(arrEnabledField.includes("5")){
          this.isFieldDisabled.dob = false;
        }

        if(arrEnabledField.includes("6")){
          this.isFieldDisabled.email = false;
        }

        if(arrEnabledField.includes("7")){
          this.isFieldDisabled.occupation = false;
        }

        if(arrEnabledField.includes("8")){
          this.isFieldDisabled.employmentSector = false;
        }

        if(arrEnabledField.includes("9")){
          this.isFieldDisabled.address = false;
        }

        if(arrEnabledField.includes("10")){
          this.isFieldDisabled.employerName = false;
        }
      },

      setInputValue(el){
        const self         = this;
        const debouncedValue = debounce(function () {
            // ID NO
            if(el.id == "identificationNo"){
              self.setIdentificationNo(el.value);
            }
            // FULL NAME
            else if(el.id == "fullname"){
              self.setFullname(el.value);
            }
            // EMAIL
            else if(el.id == "email"){
              self.setEmail(el.value);
            }
            // ADDRESS
            else if(el.id == "address"){
              self.setAddress(el.value);
            }
            // EMPLOYER NAME
            else if(el.id == "employerName"){
              self.setEmployerName(el.value);
            }
            else{
              console.log("element : ", el);
            }

            self.validateInput(el);
            self.validateNextButton();
        }, 1000);

        debouncedValue();
      },

      async getOccupationList() {
        const self = this;
        const occupationListPromise = await self.$api.staticData.getOccupationList();
        await self.setOccupationList(occupationListPromise);
        self.occupationListState = occupationListPromise;
        console.log("occupation list stored: ", occupationListPromise)

        // force re-render
        //this.componentOccupationKey += 1
        console.log("occupation re-rendered");
        await self.renderAutoComplete("occupation");
      },

      validateNextButton(){
        if(this.loggedIn && this.isUpdateAccount) { // UPDATE ACCOUNT DETAILS VIA MYINFO
          this.isNextButtonValid = this.validation.isValidForm;
        }else{ // REGISTER WITH MYINFO
          this.isNextButtonValid = this.validation.isValidForm;
        }

      },

      async finalValidationBeforeSubmit(){
        console.log("FINAL VALIDATION")
        const arrEnabledField = this.enabledField.split(',')

        if(arrEnabledField.includes("1") && this.showHideInput.fullName){
          await this.validateInput({id: "fullname", value: store.state.myinfo.fullName});
        }

        if(arrEnabledField.includes("2") && this.showHideInput.identificationNo){
          await this.validateInput({id: "identificationNo", value: store.state.myinfo.identificationNo});
        }

        if(arrEnabledField.includes("3") && this.showHideInput.gender){
          await this.validateInput({id: "gender", value: store.state.myinfo.gender});
        }

        if(arrEnabledField.includes("4") && this.showHideInput.nationality){
          await this.validateInput({id: "nationality", value: store.state.myinfo.nationalityId});
        }

        if(arrEnabledField.includes("5") && this.showHideInput.dob){
          await this.validateInput({id: "dob", value: store.state.myinfo.dob});
        }

        if(arrEnabledField.includes("6") && this.showHideInput.email){
          await this.validateInput({id: "email", value: store.state.myinfo.email});
        }

        if(arrEnabledField.includes("7") && this.showHideInput.occupation){
          await this.validateInput({id: "occupation", value: store.state.myinfo.occupation});
        }

        if(arrEnabledField.includes("8") && this.showHideInput.employmentSector){
          await this.validateInput({id: "employmentSector", value: store.state.myinfo.employmentSector});
        }

        if(arrEnabledField.includes("9") && this.showHideInput.address){
          await this.validateInput({id: "address", value: store.state.myinfo.address});
        }

        if(arrEnabledField.includes("10") && this.showHideInput.employerName){
          await this.validateInput({id: "employerName", value: store.state.myinfo.employerName});
        }

      },

      async submitForm() {
        this.showPreloader()

        await this.finalValidationBeforeSubmit()

        if(this.validation.isValidForm){

          if(this.loggedIn && this.isUpdateAccount) {
            await this.updateMyInfoAccount();
          } else {
            await this.registerMyInfoUpdate();
          }

        }
        this.hidePreloader()
      },

      async updateMyInfoAccount() {
        this.showPreloader();
        try {
          const result = await this.$api.customer.updateCustomerMyInfo(this.isMyInfoUseInAppBrowser());
          this.hidePreloader();

          if(result.status == "4851"){
            // UPDATE CUSTOME STORE - SINCE THE UPDATED DATA STORED IN UPDATE STATE
            console.log("UPDATED DoB : "+this.dob);
            store.state.customer.customerName = this.fullName;
            store.state.customer.nationalityId = this.nationalityId;
            store.state.customer.nationality = this.nationality;
            store.state.customer.dob = this.dob.split('-').reverse().join('-');
            store.state.customer.gender = this.gender;
            store.state.customer.occupation = this.occupation;
            store.state.customer.emailverified = result.result.emailVerified === 0 ? false : true;

            this.isNeedToUploadPOA = false;
            this.showPreloader();
            const customerResult = await this.$api.customer.getCustomerDetails();
            this.hidePreloader();

            if(customerResult && customerResult != undefined && this.$api.customer.isEkycNeedPOA(customerResult) && !customerResult.isPOA) {
                this.isNeedToUploadPOA = true;
            } else if(result.result.emailVerified === 0){ // NEED TO RE-VERIFY EMAIL
              this.$f7router.navigate("/account/email-verify");
            }else{
              this.$f7router.navigate("/verify/completed");
            }
          }else if(result.status == "4859"){
            this.alertCard.show    = true;
            this.alertCard.title   = this.$t('regis-dob-rule'); // UNDERAGE (< 18 y.o)
          }else if(result.status == "1214"){
            this.alertCard.show    = true;
            this.alertCard.title   = this.$t('regis-id-already-exist-error', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}); // ID ALREADY EXIST
          }else if(result.status == "1226"){ // DR-1030: data discrepancy
            this.alertCard.show    = true;
            this.alertCard.title   = this.$t('my-info-data-discrepancy-error');
          }else{
            this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            return false;
          }

        } catch(e){
          this.hidePreloader();
          this.alertCard.show    = true;
          this.alertCard.title   = (e.message.toLowerCase().includes("undefined")) ? this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) : e.message;
        }
      },

      async registerMyInfoUpdate(){
        this.showPreloader();
        const updateMyInfoPromise = await this.$api.registration.registerMyInfoUpdate(this.isMyInfoUseInAppBrowser());

        if(updateMyInfoPromise.status == "4851"){
          //this.myInfoValidation.showSheet = true; // commented for WA-371
          this.isUpdateMyInfoSuccess      = true;
          this.$f7router.navigate("/register-tnc"); // WA-371
        }
        // email exist
        else if(updateMyInfoPromise.status == "4853"){
          this.alertCard.show    = true;
          this.alertCard.title   = this.$t('regis-email-exist');
        }
        // idNo exist
        else if(updateMyInfoPromise.status == "1214"){
          if(this.isAxsr){
            // clear singpass token
            TokenService.removeToken()

            console.log("ID exist")
            this.setIsAxsRegisterIdExist(true)
            this.$f7router.navigate("/axsr-login");
            this.hidePreloader();
          }else{
            this.alertCard.show    = true;
            this.alertCard.title   = this.$t('regis-id-already-exist-error', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK});
          }
        }
        // invalid DoB
        else if(updateMyInfoPromise.status == "4859"){
          this.alertCard.show    = true;
          this.alertCard.title   = this.$t('my-info-modify-email-ws-error-3123a');
        }
        // DR-1030: data discrepancy
        else if(updateMyInfoPromise.status == "1226"){
          this.alertCard.show    = true;
          this.alertCard.title   = this.$t('my-info-data-discrepancy-error');
        }
        this.hidePreloader();
      },

      handleSheetButton(){
        this.myInfoValidation.showSheet = false;
        if(this.isUpdateMyInfoSuccess){
          //this.$f7router.navigate("/register-mobile-no");
          this.$f7router.navigate("/register-tnc");
        }
      },

      confirmToUploadPOA(isUpload) {
        this.isNeedToUploadPOA = false;
        if(isUpload) {
          this.$f7router.navigate("/verify/take-photo", { props: { doc: {id: 17, name: 'POA'}, isFromMyInfo: true }});
        } else if(!store.state.customer.emailverified){ // NEED TO RE-VERIFY EMAIL
          this.$f7router.navigate("/account/email-verify");
        }else{
          this.$f7router.navigate("/verify/completed");
        }
      },

      backButton() {
          console.log("personal details backbutton, AXS ? "+this.isAxsr)
          if(this.isAxsr && this.routerTo == "axs-landingpage"){
            TokenService.removeToken()
          }

          switch(this.routerTo) {
              case "landingpage" : this.$f7router.navigate("/"); break;
              case "account"     : this.$f7router.back({ transition: 'f7-push' });  break;
              case "home"        : this.$f7router.navigate("/home"); break;
              case "axs-landingpage" : this.$f7router.navigate("/customerDetails"); break;
              default            : this.$f7router.navigate("/register"); break;
          }
      }
    },
    components: {
      MyInfoIdNo,
      MyInfoFullname,
      MyInfoGender,
      MyInfoDob,
      MyInfoNationality,
      //MyInfoEmploymentSector,
      MyInfoEmail,
      MyInfoAddress,
      MyInfoEmployer,
      //MyInfoOccupation,
    },
    computed: {
      ...mapGetters('auth', ['loggedIn']),
      ...mapGetters('registration', ['isAxsr']),
      ...mapGetters('myinfo', [
            'address',
            'dob',
            'dobForPicker',
            'email',
            'employerName',
            'employmentSector',
            'fullName',
            'gender',
            'identificationNo',
            'nationality',
            'nationalityId',
            'occupation',
            'passExpiryDate',
            'passStatus',
            'passType',
            'residentialStatus',
            'residentialStatusId',
            'enabledField',
            'occupationList',
            'industryList',
            'nationalityList',
            'validation',
            'showHideInput',
            'routerTo'
        ])
    },
  }
</script>